import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import MCard from 'views/MCard/MCard';
import MIcon from 'views/MIcon/MIcon';

import { TimeFormat } from 'utils/enums/time-format';
import classes from './MissionControlBoard.module.scss';

type Props = {
  currentTime: moment.Moment;
};

const MissionControlBoardView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <div className={classes['container']}>
      <div className={classes['kpis']}>
        <MCard className={`${classes['kpi']} ${classes['kpi--firstRowFirstCol']}`}>
          <div className={classes['todaysActivity']}>
            <h5 className={classes['kpiTitle']}>{moment().format(TimeFormat.DotsDate)}</h5>
            <span className={classes['text']}>Activity Today</span>
          </div>
          <span className={`${classes['kpiStat']} ${classes['kpiStat__value']} ${classes['kpiStat__value--secondary']}`}>
            {props.currentTime.format(TimeFormat.FullTime)}
          </span>
          <div className={classes['activityRange']}>
            <span>000</span>
            <img className={classes['kpiImg']} src="/images/mission-controll/kpis/time.png" alt="Activity Graph"></img>
            <span>240</span>
          </div>
        </MCard>
        <MCard className={classes['kpi']}>
          <h5 className={classes['kpiTitle']}>{t('missionControl.cards.titles.co2Savings')}</h5>
          <div className={classes['details']}>
            <div>
              <span className={`${classes['kpiStat']}  ${classes['kpiStat__value']} ${classes['kpiStat__value--secondary']}`}>130</span>
              <sub className={`${classes['kpiStat']} ${classes['kpiStat__suffix']} ${classes['kpiStat__suffix--secondary']}`}>lbs</sub>
            </div>
            <div className={classes['detailsYesterday']}>
              <MIcon className={classes['detailsYesterday__icon']} name="arrowUp"></MIcon>
              <span className={classes['text']}>yesterday 100lbs</span>
            </div>
          </div>
          <div className={classes['activityRange']}>
            <span>102lb</span>
            <img className={classes['kpiImg']} src="/images/mission-controll/kpis/co2.png" alt="Activity Graph"></img>
          </div>
        </MCard>
        <MCard className={`${classes['kpi']} ${classes['kpi--firstRowLastCol']}`}>
          <h5 className={classes['kpiTitle']}>{t('missionControl.cards.titles.onTimePerfformance')}</h5>
          <div className={classes['details']}>
            <div>
              <span className={`${classes['kpiStat']} ${classes['kpiStat__value']} ${classes['kpiStat__value--secondary']}`}>83.3</span>
              <sub className={`${classes['kpiStat']} ${classes['kpiStat__suffix']} ${classes['kpiStat__suffix--secondary']}`}>%</sub>
            </div>
            <div className={classes['detailsYesterday']}>
              <MIcon className={classes['detailsYesterday__icon']} name="arrowUp"></MIcon>
              <span className={classes['text']}>yesterday 82.2%</span>
            </div>
          </div>
          <img className={classes['kpiImg']} src="/images/mission-controll/kpis/on-time-perf.png"></img>
          <span className={`${classes['text']} ${classes['text--long']}`}>240 Total / 200 On-Time Routes</span>
        </MCard>
        <MCard className={`${classes['kpi']} ${classes['kpi--lastRowFirstCol']}`}>
          <h5 className={classes['kpiTitle']}>{t('missionControl.cards.titles.vehicleEfficiency')}</h5>
          <div className={classes['details']}>
            <div>
              <span className={`${classes['kpiStat']}  ${classes['kpiStat__value']} ${classes['kpiStat__value--tertiary']}`}>94.3</span>
              <sub className={`${classes['kpiStat']} ${classes['kpiStat__suffix']} ${classes['kpiStat__suffix--tertiary']}`}>%</sub>
            </div>
            <div className={classes['detailsYesterday']}>
              <MIcon className={classes['detailsYesterday__icon']} name="arrowDown"></MIcon>
              <span className={classes['text']}>yesterday 95%</span>
            </div>
          </div>
          <img className={classes['kpiImg']} src="/images/mission-controll/kpis/vehicle-efficiency.png"></img>
          <span className={`${classes['text']} ${classes['text--long']}`}>6700 Total km / 6700 + 400 seadhead km</span>
        </MCard>
        <MCard className={classes['kpi']}>
          <h5 className={classes['kpiTitle']}>{t('missionControl.cards.titles.passengerSatisfaction')} </h5>
          <div className={`${classes['details']} ${classes['details--gap']}`}>
            <div>
              <span className={`${classes['kpiStat']} ${classes['kpiStat__value']} ${classes['kpiStat__value--secondary']}`}>4.4</span>
              <sub className={`${classes['kpiStat']} ${classes['kpiStat__suffix']} ${classes['kpiStat__suffix--secondary']}`}>/5</sub>
            </div>
            <div className={classes['detailsYesterday']}>
              <MIcon className={classes['detailsYesterday__icon']} name="arrowUp"></MIcon>
              <span className={classes['text']}>yesterday 4.3</span>
            </div>
          </div>
          <div className={classes['kpiStars']}>
            <div className={classes['kpiStarsLayer']}>
              <MIcon name="starEmpty" size="m"></MIcon>
              <MIcon name="starEmpty" size="m"></MIcon>
              <MIcon name="starEmpty" size="m"></MIcon>
              <MIcon name="starEmpty" size="m"></MIcon>
              <MIcon name="starEmpty" size="m"></MIcon>
            </div>
            <div className={`${classes['kpiStarsLayer']} ${classes['kpiStarsLayer--marked']}`}>
              <div className={classes['kpiStarsLayer__innerMarked']}>
                <MIcon name="starFull" size="m"></MIcon>
                <MIcon name="starFull" size="m"></MIcon>
                <MIcon name="starFull" size="m"></MIcon>
                <MIcon name="starFull" size="m"></MIcon>
                <MIcon name="starFull" size="m"></MIcon>
              </div>
            </div>
          </div>
          <span className={classes['text']}>6700 reviewes</span>
        </MCard>
        <MCard className={`${classes['kpi']} ${classes['kpi--lastRowLastCol']}`}>
          <h5 className={classes['kpiTitle']}>{t('missionControl.cards.titles.costPerMile')}</h5>
          <div className={classes['details']}>
            <div>
              <span className={`${classes['kpiStat']} ${classes['kpiStat__value']} ${classes['kpiStat__value--secondary']}`}>100</span>
              <sub className={`${classes['kpiStat']} ${classes['kpiStat__suffix']} ${classes['kpiStat__suffix--secondary']}`}>USD</sub>
            </div>
            <div className={classes['detailsYesterday']}>
              <MIcon className={classes['detailsYesterday__icon']} name="arrowUp"></MIcon>
              <span className={classes['text']}>yesterday 110USD</span>
            </div>
          </div>
          <div className={`${classes['activityRange']} ${classes['activityRange--costPerMile']}`}>
            <span className={classes['activityRange__text']}>100</span>
            <img className={classes['kpiImg']} src="/images/mission-controll/kpis/cost-per-mile.png"></img>
          </div>
        </MCard>
      </div>
    </div>
  );
};

MissionControlBoardView.displayName = 'MissionControlBoardView';
MissionControlBoardView.defaultProps = {};

export default MissionControlBoardView;
